import Nullstack from 'nullstack';
export default function IconChartBar({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-chart-bar",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("rect", {
    x: "3",
    y: "12",
    width: "6",
    height: "8",
    rx: "1"
  }), "   ", Nullstack.element("rect", {
    x: "9",
    y: "8",
    width: "6",
    height: "12",
    rx: "1"
  }), "   ", Nullstack.element("rect", {
    x: "15",
    y: "4",
    width: "6",
    height: "16",
    rx: "1"
  }), "   ", Nullstack.element("line", {
    x1: "4",
    y1: "20",
    x2: "18",
    y2: "20"
  }), " ");
}